const initialState = {
  currentPortfolio: null,
  requesting: false,
  generatingRecommendation: false,
  // Create portfolio
  createPortfolioLoading: false,
  createPortfolio: null,
  createPortfolioError: "",
  // Onboarding
  onboardingRequesting: false,
  onboardingError: "",
  // Get PDF Summary
  gettingSummaryPdf: false,
  gettingSummaryPdfError: false,
  // Send PDF Summary
  sendingSummaryPdf: false,
  sendingSummaryResult: "",
  sendingSummaryError: "",
  // Portfolio totals by scenario
  scenarioTotals: [],
  scenarioTotalsError: "",
  fetchingScenarioTotals: false,
  // Portfolio Details Sortable Table
  sortedPortfolioOrders: {
    order: "asc",
    orderBy: "managerDetail.Name",
  },
  // WBI Single Strategy list,
  singleStrategyList: {},
  strategyAccountMinimum: {},
  portfolioHistoryLoading: false,
  portfolioHistory: [],
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case "PORTFOLIO_FETCH_REQUESTED":
      return {
        ...state,
        requesting: true,
        sortedPortfolioOrders: {
          order: "asc",
          orderBy: "managerDetail.Name",
        },
      };
    case "PORTFOLIO_SAVE_REQUESTED":
    case "PORTFOLIO_NAME_UPDATE_REQUESTED":
    case "PORTFOLIO_STRATEGY_CHANGE_REQUESTED":
      return {
        ...state,
        requesting: true,
      };
    case "PORTFOLIO_FETCH_SUCCESS":
      const { advisorFee, custodianFees, platformFees, ...rest } =
        action.payload.data;

      return {
        ...state,
        currentPortfolio: {
          ...rest,
          uuid: action.payload.data.uuid,
        },
        requesting: false,
      };
    case "PORTFOLIO_SAVE_SUCCESS":
      return {
        ...state,
        currentPortfolio: {
          ...state.currentPortfolio,
          ...action.payload.data,
          uuid: action.payload.data.uuid,
        },
        requesting: false,
      };
    case "PORTFOLIO_FETCH_FAIL":
    case "PORTFOLIO_SAVE_FAIL":
    case "PORTFOLIO_NAME_UPDATE_FAIL":
    case "PORTFOLIO_STRATEGY_CHANGE_FAIL":
      return {
        ...state,
        requesting: false,
      };
    case "CLEAR_CURRENT_PORTFOLIO":
      return {
        ...state,
        currentPortfolio: null,
        gettingSummaryPdfError: false,
        onboardingError: "",
        sendingSummaryResult: "",
        sendingSummaryError: "",
      };
    case "ONBOARD_CLIENT_REQUESTED":
      return {
        ...state,
        onboardingRequesting: true,
        onboardingError: "",
      };
    case "ONBOARD_CLIENT_FAIL":
      return {
        ...state,
        onboardingRequesting: false,
        onboardingError: action.payload.response.data.error,
      };
    case "PORTFOLIO_PDF_REQUESTED":
      return {
        ...state,
        gettingSummaryPdf: true,
        gettingSummaryPdfError: false,
      };
    case "PORTFOLIO_PDF_SUCCESS":
      return {
        ...state,
        gettingSummaryPdf: false,
      };
    case "PORTFOLIO_PDF_FAIL":
      return {
        ...state,
        gettingSummaryPdf: false,
        gettingSummaryPdfError: true,
      };
    case "SEND_PORTFOLIO_PDF_REQUESTED":
      return {
        ...state,
        sendingSummaryPdf: true,
        sendingSummaryResult: "",
        sendingSummaryError: "",
      };
    case "SEND_PORTFOLIO_PDF_SUCCESS":
      return {
        ...state,
        sendingSummaryResult: action.payload.message,
        sendingSummaryPdf: false,
      };
    case "SEND_PORTFOLIO_PDF_FAIL":
      return {
        ...state,
        sendingSummaryPdf: false,
        sendingSummaryError: action.payload.response.data.error,
      };
    case "PORTFOLIO_SCENARIO_TOTALS_REQUESTED":
      return {
        ...state,
        fetchingScenarioTotals: true,
        scenarioTotalsError: "",
      };
    case "PORTFOLIO_SCENARIO_TOTALS_SUCCESS":
      return {
        ...state,
        scenarioTotals: action.payload.data,
        fetchingScenarioTotals: false,
      };
    case "PORTFOLIO_SCENARIO_TOTALS_FAIL":
      return {
        ...state,
        fetchingScenarioTotals: false,
        scenarioTotalsError: action.payload.response.data.error,
      };
    case "PORTFOLIO_CREATE_REQUESTED":
      return {
        ...state,
        createPortfolioLoading: true,
        createPortfolioError: "",
      };
    case "PORTFOLIO_CREATE_SUCCESS":
      return {
        ...state,
        createPortfolio: action.payload.data,
        createPortfolioLoading: false,
      };
    case "PORTFOLIO_CREATE_FAIL":
      return {
        ...state,
        createPortfolioLoading: false,
        createPortfolioError: action.payload.response.data.error,
      };
    case "SAVE_SORTED_PORTFOLIO_ORDERS":
      return {
        ...state,
        sortedPortfolioOrders: {
          order: action.payload.order,
          orderBy: action.payload.orderBy,
        },
      };
    case "PORTFOLIO_NAME_UPDATE_SUCCESS":
    case "PORTFOLIO_STRATEGY_CHANGE_SUCCESS":
      return {
        ...state,
        requesting: false,
        currentPortfolio: {
          ...state.currentPortfolio,
          ...action.payload.data,
        },
      };
    case "LOAD_USER_APPLICATION_STATE_SUCCESS":
      return {
        ...state,
        singleStrategyList: action.payload.singleStrategies,
        strategyAccountMinimum: action.payload.strategyAccountMinimum
      };
    case "LOAD_USER_APPLICATION_STATE_FAIL":
      return {
        ...state,
        singleStrategyList: {},
        strategyAccountMinimum: {}
      };
    case "UPDATE_FEES_ADVISOR_RATE_PORTFOLIO_SUCCESS":
      return {
        ...state,
        currentPortfolio: {
          ...state.currentPortfolio,
          uuid: action.payload.portfolioId,
          name: action.payload.portfolioName || state.currentPortfolio.name,
        },
      };
    case "PORTFOLIO_FETCH_HISTORY_REQUESTED":
      return {
        ...state,
        portfolioHistoryLoading: true,
      };
    case "PORTFOLIO_FETCH_HISTORY_SUCCESS":
      return {
        ...state,
        portfolioHistoryLoading: false,
        portfolioHistory: action.payload.data,
      };
    case "PORTFOLIO_FETCH_HISTORY_FAILED":
      return {
        ...state,
        portfolioHistoryLoading: false,
        portfolioHistory: [],
      };
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/portfolio.reducer.js